import { store } from '@betacrew/jars-flux'
import { USPS_MAIL_TO_RECIPIENT_LOADING_STATES } from './constants';

export const componentKey = "USPS_MAIL_TO_RECIPIENT";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingStates: (state, action) => {
            state.loadingStates = action.payload;
        },

        setUSPSMailToRecipientFees: (state, action) => {
            state.USPSMailToRecipientFees = action.payload;
        }
    },
    initialReducerState: {
        loadingStates: { state: USPS_MAIL_TO_RECIPIENT_LOADING_STATES.USPS_MAIL_FEE_READY },
        USPSMailToRecipientFees: 0
    }
})

export const { setLoadingStates, setUSPSMailToRecipientFees } = actions; 
